import { zodResolver } from '@hookform/resolvers/zod';
import { Resolver, UseFormProps } from 'react-hook-form';
import { z } from 'zod';

import { i18n } from '@/utils/i18n';

const getPasswordMinLengthMessage = () => i18n.t('validation.passwordMinLength');
const getPasswordsMustMatchMessage = () => i18n.t('validation.passwordsMustMatch');

export const setPasswordFormSchema = z
  .object({
    password: z.string().min(6, { message: getPasswordMinLengthMessage() }),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: getPasswordsMustMatchMessage(),
    path: ['confirmPassword'],
  });

export type SetPasswordEntity = z.infer<typeof setPasswordFormSchema>;

const setPasswordResolver: Resolver<SetPasswordEntity> = zodResolver(setPasswordFormSchema) as never;

export const PasswordFormOptions: UseFormProps<SetPasswordEntity> = {
  mode: 'onSubmit',
  resolver: setPasswordResolver,
};
